<template>
  <pop-up-message :message="message" v-if="isMessageVisible" v-on:close="isMessageVisible=false"/>

  <page-scaffold>
    <div class="bonus-page">
      <!--      <div class="title" style="grid-area: title-balance">Мой баланс</div>-->
      <div class="title" style="grid-area: title-history">Бонусы</div>
      <!--      <div class="title"-->
      <!--           style="grid-area: balance; margin-top: 12px; font-size: 4rem; line-height: 4rem;  font-family: 'Mont', serif; color: #58B1DA">-->
      <!--        214 ₽-->
      <!--      </div>-->
	<div class="bonus-up" style="margin-top: 32px; height: 100%">
	<div class="title" style="color: white; margin-top: 0"></div>

	<div class="v-search-bar">
    <outlined-button-with-icon @click="$router.push('/bonusspend')" :icon="require('@/assets/ic_card.svg')" :title="'Потратить бонусы'"/>
	</div>
      </div>
      <div class="history">
        <item-bonus v-for="item in history" v-bind:key="item.id" :item="item"/>
      </div>
    </div>


  </page-scaffold>


</template>

<script>
import PageScaffold from "./page-scaffold";
import ItemBonus from "./item-bonus";
import axios from "axios";
import PopUpMessage from "./pop-up-message";

export default {
  name: "page-bonus",
  components: {PopUpMessage, ItemBonus, PageScaffold},
  data: () => {
    return {
      history: Array,
      amount: "",
      message: "Укажите сумму платежа",
      isMessageVisible: false
    }
  },
  methods: {
  },
  mounted() {
    axios({
      method: "GET",
      url: "v1/bonus/history",
      headers: {Authorization: `Bearer ` + localStorage.token},
    }).then(response => {
      this.history = response.data.response
    })
  }
}
</script>

<style scoped>
.bonus-page {
  padding-right: 24px;
  width: calc(100%);
  height: 100%;
  overflow-y: hidden;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: max-content max-content 1fr;
  grid-template-areas:
      "bonuswidget title-history"
      "bonuswidget history"
      "bonuswidget history"
}


.bonus-up {
  margin-left: 16px;
  text-align: center;
  padding: 16px 0;
  background: #58B1DA;
  margin-right: 16px;
  height: max-content;
  width: 350px;
  border-radius: 24px;
  grid-area: bonuswidget;
}

.bonus-up .sum {
  width: calc(100% - 48px);
  font-family: "Mont", serif;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: white;
  padding-top: 10px;
  padding-bottom: 8px;
  margin-left: 24px;
  margin-right: 24px;
  text-align: center;
  border-width: 0;
  outline: none;
  height: 32px;
  background: #4895b9;
  border-radius: 16px;
}


.title {
  padding-left: 16px;
  font-family: "Century Gothic", serif;
  font-weight: bold;
  color: #2D666E;
  height: max-content;
  justify-self: start;
  white-space: nowrap;
  font-size: 1.4rem;
  margin-top: 24px;
  margin-bottom: 24px;
}

.history {
  grid-area: history;
  overflow-y: scroll;
  padding: 16px;
}

.history::-webkit-scrollbar {
  width: 0;
  height: 0;
}


.btn {
  cursor: pointer;
  padding: 16px 14px 14px 14px;
  background: white;
  margin-right: 24px;
  margin-left: 24px;
  border-radius: 16px;
  box-shadow: 0 0 24px rgba(255, 255, 255, 0.3);
  width: calc(100% - 48px - 28px);
  color: #58B1DA;
  font-family: "Mont", serif;
  font-weight: bolder;
  margin-top: 16px;
  line-height: 1rem;
  font-size: 1rem;
}

.btn:hover {
  box-shadow: 0 0 24px rgba(0, 153, 255, 0.6);
}

.btn-text {
  font-family: "Mont", serif;
  font-weight: bolder;
  margin-top: 16px;
  line-height: 1rem;
  color: #ffffff;
  font-size: 1rem;
}


::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color: rgba(255, 255, 255, 0.97);
}

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: white;
  opacity: 0.5;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: white;
  opacity: 0.5;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: white;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: rgba(255, 255, 255, 0.5);
}

::placeholder { /* Most modern browsers support this now. */
  color: rgba(255, 255, 255, 0.5);
}
</style>
